import { render, staticRenderFns } from "./TermsOfServiceComponent.vue?vue&type=template&id=6cadc724&"
import script from "./TermsOfServiceComponent.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports